export enum RunType {
  Regular = 'regular',
  AddDocs = 'addDocs',
  /**
   * Retired: no new runs are created with this type, and the chronos state machine
   * no longer has a path for it. It survives for the historical `run_v2` rows that
   * carry it, which the members below and the run-type label still classify. The
   * value cannot be dropped without rewriting those rows — the column is a Postgres
   * enum bound to this one — and rewriting them would lose the record that those
   * runs regenerated the synopsis as well as adding documents.
   */
  AddDocsUpdateSynopsis = 'addDocsUpdateSynopsis',
  UpdateSynopsis = 'updateSynopsis',
  UpdateInconsistencies = 'updateInconsistencies',
  DeleteDocuments = 'deleteDocuments',
  Reprocess = 'reprocess',
}

/**
 * Run types that uploaded and processed actual documents. Only these are eligible
 * for the "Rerun failed jobs" feature — synopsis/inconsistency/delete runs have
 * no per-doc processing state to retry.
 */
export const REPROCESSABLE_RUN_TYPES: readonly RunType[] = [
  RunType.Regular,
  RunType.AddDocs,
  RunType.AddDocsUpdateSynopsis,
] as const;

/** Run types that carry no documents and write no pipeline manifest. */
export const METADATA_ONLY_RUN_TYPES: readonly RunType[] = [
  RunType.UpdateSynopsis,
  RunType.DeleteDocuments,
] as const;
